import {inject, Ref, computed, unref} from 'vue'
import {useRoute, routerViewLocationKey, RouteLocationNormalizedLoaded} from 'vue-router'
import {useCurrentRoute} from '@toolify/client/src/modules/routes/composables/useCurrentRoute'

export function useLocalRoute() {
  const globalRoute = useRoute()
  const providedRoute = useCurrentRoute()
  const routerViewRouteRef = inject<Ref<RouteLocationNormalizedLoaded>>(routerViewLocationKey, null)
  const route = computed<RouteLocationNormalizedLoaded>(() => {
    if (providedRoute?.route) {
      return unref(providedRoute.route)
    }
    return routerViewRouteRef ? unref(routerViewRouteRef) : globalRoute
  })
  return route
}
